/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { LLCTransaction } from '@models/llc-mortgages';
import { MortgageTransactionStatus } from '@models/mortgages/mortgage-base';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class LLCMortgageRepoService extends Repo<LLCTransaction, unknown> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	GetCollectionPath(): string {
		return CollectionPaths.business_mortgages_llc_mortgages(this.businessId);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	getValidTransactions = (): Observable<any[]> =>
		this.All(null, (ref) => ref.where('valid', '==', true));

	getNewTransactions = (): Observable<{ id: string }[]> =>
		this.All(null, (ref) =>
			ref
				.where('valid', '==', true)
				.where('status', 'in', [
					MortgageTransactionStatus.PENDING_ACCEPTANCE,
					null,
				]),
		);

	getUnassignedTransactions = (): Observable<any> =>
		this.All(null, (ref) =>
			ref
				.where('valid', '==', true)
				.where('status', '==', MortgageTransactionStatus.ACTIVE),
		).pipe(
			map((x: LLCTransaction[]) =>
				x.filter((y: LLCTransaction) => !(y?.matterId?.length > 0)),
			),
		);
}
